import { render, staticRenderFns } from "./longRentPaymentRecord.vue?vue&type=template&id=5ba7e7b7&scoped=true&"
import script from "./longRentPaymentRecord.vue?vue&type=script&lang=js&"
export * from "./longRentPaymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./longRentPaymentRecord.vue?vue&type=style&index=0&id=5ba7e7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7e7b7",
  null
  
)

export default component.exports